/**
 * TimeDuration enum matching the backend API
 * Must match: Stark.EXO.API.Data.Enumerations.TimeDuration
 */
export enum TimeDuration {
  LastHour = 'last hour',
  LastTwelveHour = 'last 12 hours',
  LastDay = 'last day',
  LastWeek = 'last week',
  LastMonth = 'last month',
  LastYear = 'last year'
}

export const TIME_RANGES = [
  {
    value: TimeDuration.LastHour,
    text: 'Last Hour'
  },
  {
    value: TimeDuration.LastDay,
    text: 'Last Day'
  },
  {
    value: TimeDuration.LastWeek,
    text: 'Last Week'
  },
  {
    value: TimeDuration.LastMonth,
    text: 'Last Month'
  },
  {
    value: TimeDuration.LastYear,
    text: 'Last Year'
  }
];